import { ServiceConfig } from 'angular-odata';

//#region ODataApi Imports
//#endregion

export const WettbewerberServiceConfig = {
  name: "Wettbewerber",
  annotations: []
} as ServiceConfig;